import createIcon from "components/elements/Icons/create-icon";

export default createIcon(
  "Clock",
  [
    [
      "path",
      {
        d: "M3.13397 12C3.13397 7.02944 7.16341 3 12.134 3C17.1045 3 21.134 7.02944 21.134 12C21.134 16.9706 17.1045 21 12.134 21C7.16341 21 3.13397 16.9706 3.13397 12ZM12.134 1C6.05884 1 1.13397 5.92487 1.13397 12C1.13397 18.0751 6.05884 23 12.134 23C18.2091 23 23.134 18.0751 23.134 12C23.134 5.92487 18.2091 1 12.134 1ZM13.134 6C13.134 5.44772 12.6863 5 12.134 5C11.5817 5 11.134 5.44772 11.134 6V12C11.134 12.3788 11.348 12.725 11.6868 12.8944L15.6868 14.8944C16.1807 15.1414 16.7814 14.9412 17.0284 14.4472C17.2754 13.9532 17.0752 13.3526 16.5812 13.1056L13.134 11.382V6Z",
      },
    ],
  ],
  "currentColor"
);
